import { render } from "./quizMultiplePath.vue?vue&type=template&id=f7c154a6"
import script from "./quizMultiplePath.vue?vue&type=script&lang=js"
export * from "./quizMultiplePath.vue?vue&type=script&lang=js"

import "./quizMultiplePath.vue?vue&type=style&index=0&id=f7c154a6&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__